{
  "name": "steto-uploader-web",
  "version": "1.1.2",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "oxlint",
    "fmt": "oxfmt",
    "typecheck": "tsc --noEmit",
    "analyze": "vite-bundle-visualizer --open --sourcemap",
    "knip": "knip"
  },
  "dependencies": {
    "@emotion/css": "11.13.5",
    "@emotion/react": "11.14.0",
    "@emotion/styled": "11.14.1",
    "@floating-ui/react": "0.27.20",
    "@mui/material": "9.2.0",
    "@mui/x-date-pickers": "9.9.0",
    "@sentry/react": "9.47.1",
    "@steto-care/steto-query": "1.3.0",
    "@tanstack/devtools-vite": "0.8.1",
    "@tanstack/react-devtools": "0.10.8",
    "@tanstack/react-query": "5.101.2",
    "@tanstack/react-query-devtools": "5.101.2",
    "@tanstack/react-router": "1.170.18",
    "@tanstack/react-router-devtools": "1.167.0",
    "axios": "1.18.1",
    "camelcase": "9.0.0",
    "decamelize": "6.0.1",
    "i18next": "26.3.6",
    "i18next-browser-languagedetector": "8.2.1",
    "luxon": "3.7.2",
    "posthog-js": "1.297.4",
    "react-error-boundary": "6.1.2",
    "react-i18next": "17.0.9",
    "react-toastify": "11.1.0",
    "zod": "4.4.3",
    "zustand": "5.0.14"
  },
  "devDependencies": {
    "@tanstack/router-plugin": "1.168.20",
    "@types/luxon": "3.7.2",
    "@types/node": "25.9.1",
    "@types/react": "19.2.17",
    "@types/react-dom": "19.2.3",
    "@types/w3c-web-serial": "1.0.8",
    "@types/w3c-web-usb": "1.0.14",
    "@vitejs/plugin-react": "6.0.3",
    "knip": "6.27.0",
    "oxfmt": "0.59.0",
    "oxlint": "1.74.0",
    "react": "19.2.7",
    "react-dom": "19.2.7",
    "typescript": "7.0.2",
    "vite": "8.1.4",
    "vite-bundle-visualizer": "1.2.1",
    "vite-plugin-svgr": "5.2.0"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ],
    "staging": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "packageManager": "pnpm@11.22.0",
  "knip": {
    "ignoreExportsUsedInFile": true,
    "ignore": [
      "src/storybook/**",
      "src/public/**"
    ]
  }
}
